import s from './header.module.scss'
import { NavLink } from 'react-router-dom'
import {Container} from "../../components/container"
import { Space,Drawer } from 'antd'
import { useState } from 'react'
import {MenuOutlined} from "@ant-design/icons"
import {FaHome,FaLayerGroup} from "react-icons/fa"
import {BsPersonFill,BsChatFill} from "react-icons/bs"
// import {IoNewspaper} from "react-icons/io5"
import {Logo} from "../logo"
import {useTranslation} from "react-i18next"

export const Header = () => {
  const[open,setOpen] = useState(false)
  const {t} = useTranslation()
  return (
    <div className={s.header}>
        <Container className={s.container}>
            <div className={s.logo}>
              <Logo color='var(--color-primary)'/>
            </div>
            <div className={s.menus}>
              <Space size={56}>
                  <NavLink to="/">{t("header_home")}</NavLink>
                  <NavLink to="/about">{t("header_about")}</NavLink>
                  <NavLink to="/portfolio">{t("header_portfolio")}</NavLink>
                  {/* <NavLink to="/news">News</NavLink> */}
                  <NavLink to="/contact">{t("header_contact")}</NavLink>
              </Space>
            </div>
            <div className={s.icons}>
              <MenuOutlined onClick={()=>setOpen(true)} style={{verticalAlign:"middle",color:"#fff",fontSize:30}}/>
            </div>
            <Drawer className={s.drawer} open={open} width={280} onClose={()=>setOpen(false)}>
              <Space className={s.space} direction='vertical'>
                  <NavLink onClick={()=>setOpen(false)} to="/"><FaHome style={{verticalAlign:"middle",fontSize:20}}/>&nbsp;&nbsp;{t("header_home")}</NavLink>
                  <NavLink onClick={()=>setOpen(false)} to="/about"><BsPersonFill style={{verticalAlign:"middle",fontSize:20}}/>&nbsp;&nbsp;{t("header_about")}</NavLink>
                  <NavLink onClick={()=>setOpen(false)} to="/portfolio"><FaLayerGroup style={{verticalAlign:"middle",fontSize:20}}/>&nbsp;&nbsp;{t("header_portfolio")}</NavLink>
                  {/* <NavLink onClick={()=>setOpen(false)} to="/news"><IoNewspaper style={{verticalAlign:"middle",fontSize:20}}/>&nbsp;&nbsp;News</NavLink> */}
                  <NavLink onClick={()=>setOpen(false)} to="/contact"><BsChatFill style={{verticalAlign:"middle",fontSize:20}}/>&nbsp;&nbsp;{t("header_contact")}</NavLink>
              </Space>
            </Drawer>


        </Container>
    </div>
  )
}